import { ReactElement } from 'react'
import { Small } from '../../typography'
import Figure from 'react-bootstrap/Figure'
import {
  SubHeaderContainer,
  SubjectInfo,
  ContentWrapper,
  SubHeaderWrapper,
  DropdownWrapper,
  SectionTitle
} from './subcomponents'
import { colors } from '../../const/theme'
import BackButton from '../BackButton'
import capitalize from '../../helpers/capitalize'
import EditableDropdown from '../EditableDropdown'
import { DropdownListProps } from '../EditableDropdown/typings'

interface SubHeaderProps {
  handleBack?: () => void
  title: string
  logo?: string
  subTitle?: string
  prefix?: ReactElement
  titleColor?: string
  dropdownList?: Array<DropdownListProps>
  //eslint-disable-next-line no-unused-vars
  handleDropdownSelect?: (item: any) => void
  DropDownDefaultValue?:any
}

const SubHeader = ({
  handleBack,
  title = '',
  subTitle = '',
  logo = '',
  prefix,
  titleColor = colors.black,
  dropdownList,
  handleDropdownSelect,
  DropDownDefaultValue
}: SubHeaderProps): ReactElement => {
  return (
    <SubHeaderContainer id="sub-header-wrapper">
      <SubHeaderWrapper>
        <ContentWrapper>
          {handleBack && <BackButton handleBack={handleBack} />}
          {logo && (
            <Figure>
              <Figure.Image
                width={70}
                height={70} 
                alt="subject-logo"
                src={logo}
              />
            </Figure>
          )}
          {prefix && prefix}
          <SubjectInfo>
            <SectionTitle color={titleColor}>{capitalize(title)}</SectionTitle>
            {!!subTitle && <Small hasPadding>{subTitle}</Small>}
          </SubjectInfo>
        </ContentWrapper>
        {dropdownList && dropdownList.length && (
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={dropdownList}
              handleSelect={handleDropdownSelect}
              placeholder="Topic"
              defaultValue={DropDownDefaultValue}
            />
          </DropdownWrapper>
        )}
      </SubHeaderWrapper>
    </SubHeaderContainer>
  )
}

export default SubHeader
